import React, { FC } from 'react';
//context
import { useDetailsQuoteContext } from 'contexts/DetailsQuote';
//styles
import * as S from './styles';

interface IDnDProps {
  endSecondRenderMapProduct?: boolean;
  isDragging?: boolean;
  className?: string;
  outStock?: boolean;
  sequence?: number;
  children: any;
  index: number;
  item: any;
}

export const DnDCard: FC<IDnDProps> = (props) => {
  const {
    item,
    children,
    outStock,
    className,
    isDragging,
    endSecondRenderMapProduct
  } = props;
  const { sequence } = useDetailsQuoteContext();

  const notBlocked = sequence === 0 || (sequence === 1 && item.sequentialSuggestion !== "1");

  return (
    <S.DnDCard
      outStock={outStock}
      className={className}
      isDragging={isDragging ?? false}
      blocked={!notBlocked || !endSecondRenderMapProduct}
    >
      {children}
    </S.DnDCard>
  );
};
